module.exports = {
	"config": {
		"siteTitle": "Badness 10.0000",
		"linkPrefix": "/Badness10k"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "algebaric-patterns-identity-element.md",
				"ext": "md",
				"name": "algebaric-patterns-identity-element",
				"extname": ".md",
				"basename": "algebaric-patterns-identity-element.md",
				"dirname": "",
				"stem": "algebaric-patterns-identity-element",
				"path": "algebaric-patterns-identity-element.md"
			},
			"requirePath": "algebaric-patterns-identity-element.md",
			"path": "/algebraic-patterns-identity-element/",
			"data": {
				"title": "Algebraic patterns — Identity element",
				"date": "2016-06-29T00:00:00.000Z",
				"path": "/algebraic-patterns-identity-element"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "algebraic-patterns-category.md",
				"ext": "md",
				"name": "algebraic-patterns-category",
				"extname": ".md",
				"basename": "algebraic-patterns-category.md",
				"dirname": "",
				"stem": "algebraic-patterns-category",
				"path": "algebraic-patterns-category.md"
			},
			"requirePath": "algebraic-patterns-category.md",
			"path": "/algebraic-patterns-category/",
			"data": {
				"title": "Algebraic patterns — Category",
				"date": "2016-11-04T00:00:00.000Z",
				"path": "/algebraic-patterns-category"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "algebraic-patterns-monoid-morphism.md",
				"ext": "md",
				"name": "algebraic-patterns-monoid-morphism",
				"extname": ".md",
				"basename": "algebraic-patterns-monoid-morphism.md",
				"dirname": "",
				"stem": "algebraic-patterns-monoid-morphism",
				"path": "algebraic-patterns-monoid-morphism.md"
			},
			"requirePath": "algebraic-patterns-monoid-morphism.md",
			"path": "/algebraic-patterns-monoid-morphism/",
			"data": {
				"title": "Algebraic patterns — Monoid morphisms",
				"date": "2016-08-10T00:00:00.000Z",
				"path": "/algebraic-patterns-monoid-morphism"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "algebraic-patterns-monoid.md",
				"ext": "md",
				"name": "algebraic-patterns-monoid",
				"extname": ".md",
				"basename": "algebraic-patterns-monoid.md",
				"dirname": "",
				"stem": "algebraic-patterns-monoid",
				"path": "algebraic-patterns-monoid.md"
			},
			"requirePath": "algebraic-patterns-monoid.md",
			"path": "/algebraic-patterns-monoid/",
			"data": {
				"title": "Algebraic patterns — Monoid",
				"date": "2016-07-21T00:00:00.000Z",
				"path": "/algebraic-patterns-monoid"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "algebraic-patterns-semigroup.md",
				"ext": "md",
				"name": "algebraic-patterns-semigroup",
				"extname": ".md",
				"basename": "algebraic-patterns-semigroup.md",
				"dirname": "",
				"stem": "algebraic-patterns-semigroup",
				"path": "algebraic-patterns-semigroup.md"
			},
			"requirePath": "algebraic-patterns-semigroup.md",
			"path": "/algebraic-patterns-semigroup/",
			"data": {
				"title": "Algebraic patterns — Semigroup",
				"date": "2016-07-14T00:00:00.000Z",
				"path": "/algebraic-patterns-semigroup"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "escaping-hell-with-monads.md",
				"ext": "md",
				"name": "escaping-hell-with-monads",
				"extname": ".md",
				"basename": "escaping-hell-with-monads.md",
				"dirname": "",
				"stem": "escaping-hell-with-monads",
				"path": "escaping-hell-with-monads.md"
			},
			"requirePath": "escaping-hell-with-monads.md",
			"path": "/escaping-hell-with-monads/",
			"data": {
				"title": "Escaping Hell with Monads",
				"date": "2017-05-07T22:12:03.284Z",
				"path": "/escaping-hell-with-monads/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "functional-waterflow.md",
				"ext": "md",
				"name": "functional-waterflow",
				"extname": ".md",
				"basename": "functional-waterflow.md",
				"dirname": "",
				"stem": "functional-waterflow",
				"path": "functional-waterflow.md"
			},
			"requirePath": "functional-waterflow.md",
			"path": "/functional-waterflow/",
			"data": {
				"title": "A functional solution to Twitter's waterflow problem",
				"author": "Philip Nilsson",
				"date": "2013-10-11T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "memento.md",
				"ext": "md",
				"name": "memento",
				"extname": ".md",
				"basename": "memento.md",
				"dirname": "",
				"stem": "memento",
				"path": "memento.md"
			},
			"requirePath": "memento.md",
			"path": "/memento-spaghetti/",
			"data": {
				"title": "Memento spaghetti",
				"date": "2017-06-28T00:00:00.000Z",
				"path": "/memento-spaghetti"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0